import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import {
  NbButtonModule,
  NbIconModule,
  NbInputModule,
  NbOptionModule,
  NbSpinnerModule,
  NbUserModule
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { ListAdderComponent } from './list-adder/list-adder.component';

/**
 * Shared module hosting the reusable form/picker controls so they can be
 * consumed both from AppModule and from feature modules (e.g. CvModule)
 * without redeclaring them. A component must be declared in exactly one
 * NgModule; ListAdderComponent lives here.
 *
 * NbUserModule is re-exported so consumers that pair <bst-list-adder> with
 * <nb-user> (e.g. CvDocumentsHubDialogComponent) get it for free.
 */
@NgModule({
  declarations: [ListAdderComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    OverlayModule,
    NbInputModule,
    NbButtonModule,
    NbIconModule,
    NbOptionModule,
    NbSpinnerModule,
    NbUserModule,
    TranslateModule.forChild()
  ],
  exports: [ListAdderComponent, NbUserModule]
})
export class ControlsModule {}
